import script from "./ParticipantPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParticipantPage.vue?vue&type=script&setup=true&lang=ts"

import "./ParticipantPage.vue?vue&type=style&index=0&id=a6fee69e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6fee69e"]])

export default __exports__